import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Flex, Heading, Box, Button, HStack } from '@chakra-ui/react'

import { listarAplicacao } from '../../../api/aplicativo'
import Paginacao from '../../../components/common/paginacao/paginacao'
import SettingsBreadcrumb from '../../../components/SettingsBreadcrumb'
import TabelaAplicativo from './tabela-aplicativo'

const GerenciarAplicativo = () => {
  const [aplicativos, setAplicativos] = useState<any[]>([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [loading, setLoading] = useState<boolean>(false)
  const navigate = useNavigate()

  useEffect(() => {
    const fetchAplicativos = async () => {
      setLoading(true)
      try {
        const data = await listarAplicacao(paginaAtual, 10)

        setAplicativos(
          data.dados.map((aplicativo: any) => ({
            id: aplicativo.seqAplicativo,
            nomeAplicativo: aplicativo.dscAplicativo,
            ativo: aplicativo.numRegistro === 1
          }))
        )
        setTotalPages(data.totalPaginas)
      } catch (error) {
        console.error('Erro ao buscar aplicativos:', error)
        setAplicativos([])
      } finally {
        setLoading(false)
      }
    }

    fetchAplicativos()
  }, [paginaAtual])

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading
        mt="30px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Aplicativo
      </Heading>

      {/* Search bar */}
      <Box m="40px 0" w="100%">
        <HStack spacing={5}>
          <Button
            color="#fff"
            bgColor="#1789FC"
            _hover={{
              bgColor: '#1468C9'
            }}
            onClick={() => navigate('novo-aplicativo')}
          >
            Novo Aplicativo
          </Button>
        </HStack>
      </Box>

      <Box>
        <TabelaAplicativo
          listaAplicativo={aplicativos}
          listaVazia="Nenhum dado disponível."
          loading={loading}
        />
      </Box>

      <Paginacao
        paginaAtual={paginaAtual}
        totalPages={totalPages}
        onPageChange={setPaginaAtual}
      />
    </Flex>
  )
}

export default GerenciarAplicativo
